export const EN_TRANSLATION = {
  store: {
    storeInformation: '店舗情報',
    storeName: '店 名',
    branchName: '支店名',
    englishName: '英語名',
    furigana: 'フリガナ',
    alias: '別名表記',
    postalCode: '郵便番号',
    telephone: '電話番号',
    location: '所在地',
    state: '都道府県',
    cityStreet: '市町村・番地',
    buildingFloor: 'ビル名・階数',
    nearestStation: '最寄り駅',
    freeSpace: 'フリースペース',
    dayOfWeek: ' 曜日',
    holidays: '定休日',
    detailsInformation: '詳細情報',
    reserveOption: '予約',
    reserve: '予約サイトURL',
    deliveryURL: 'デリバリーサイトURL',
    orderByEmailUrl: '通販サイトURL',
    paymentMethods: '支払い方法',
    charter: '貸し切り',
    charterComment: '例）10人以上で相談可',
    seatComment: '例）近隣にコインパーキングあり',
    seatSmokingComment: '例）全席禁煙',
    carParkComment: '台',
    noOfSeats: '席数',
    smoking: '喫煙',
    parking: '駐車場',
    webSns: 'Web・SNS',
    paypay: 'PayPay',
    creditCard: 'クレジットカード',
    npPay: 'NP掛け払い',
    inputURLHolder: 'URLをご記入ください。',
    yes: 'あり',
    no: 'なし',
    impossible: '不可',
    possible: '可',
    storeHP: '店舗HP',
    instagram: 'インスタグラム',
    facebook: 'Facebook',
    twitter: 'Twitter',
    gmbSyncLabelInactive: 'ゲマトスマイビジネスを利用して、Google My Businessの店舗情報及び口コミをゲマトスに反映できます。ゲマトスマイビジネスの詳細は',
    gmbSyncLabelInactiveLink: 'こちら',
    gmbSyncLabelActive: 'ゲマトスマイビジネス利用中：',
    gmbSyncDescriptionActive: 'Google My Businessの店舗情報及び口コミをゲマトスに反映しております。　最新更新日：',
    gmbSyncLabelActiveLink: '店舗情報を更新',
    topPosts: {
      savePostSuccessfully: '保存が完了しました',
      savePostFailed: '表示順を設定してください',
      latestPosts: '最新情報',
      postList: '情報一覧',
      newPost: '新規追加',
      displayRanking: '表示順（昇順）: ',
      title: 'タイトル',
      content: '内容',
      orderNumber: '表示順',
      publicSetting: '公開設定',
      public: '公開',
      private: '非公開',
      contentPlaceholder: '150文字以内で入力してください。'
    },
    reviews: {
      sendRequestSuccessfully: 'リクエストを正常に送信',
      reviewManagement: '口コミ管理',
      reviewList: '口コミ一覧',
      review: '口コミ',
      times: '件',
      gmtsReviewGuide: '＊ GMTS口コミガイドライン',
      sendDeletingRequest: '選択した問題のある口コミをGMTSに削除依頼する',
      saveBtn: '選択した口コミを上位に表示する',
      setPriorityReview: '口コミを上位に設定しました'
    },
    businessHours: {
      saveBusinessHoursSuccessfully: '保存が完了しました',
      saveBusinessHoursFailed: '営業時間の節約に失敗しました',
      businessHours: '営業時間',
      Sunday: '日曜日',
      Monday: '月曜日',
      Tuesday: '火曜日',
      Wednesday: '水曜日',
      Thursday: '木曜日',
      Friday: '金曜日',
      Saturday: '土曜日',
      regularHoliday: '定休日',
      holiday: '休日',
      removeDay: '営業時間を削除する',
      addDay: '営業時間を追加',
      save: '保存',
      cancel: 'キャンセル',
      specialDays: ' 特別営業時間',
      specialDaysDesc: '※祝祭日や臨時休業など、営業時間が普段と異なる場合、こちらから設定できます。'
    },
    priceRange: {
      priceRange: '価格帯',
      foodCategory: '料理のジャンル',
      purposeCategory: '目的・利用シーン',
      purposeCategoryNote: '目的・利用シーン詳細',
      extraCategory: '空間・設備',
      Lunch: 'ランチ',
      Dinner: 'ディナー',
      Party: '宴会予算'
    },
    validation: {
      maxLength: '30文字までご入力ください。',
      typeStoreName: '全角、半角文字列を入力してください。',
      typeEnglishName: '半角英数字を30文字までご入力ください。',
      typeFurigana: '全角フリガナを30文字までご入力ください。',
      numberSeat: '0以上の数字を入力してください'
    }
  },
  leftSidebar: {
    homeMenuLabel: 'トップ',
    storeInfoMenuLabel: '店舗情報',
    menusMenuLabel: 'メニュー',
    menusMenuSubLabel1: 'カテゴリ一覧',
    menusMenuSubLabel2: 'メニュー一覧',
    videoManagementMenuLabel: '動画管理',
    analysisMenuLabel: 'アクセス解析',
    billingManagementMenuLabel: '課金管理',
    billingManagementMenuSubLabel1: '有料コンテンツ一覧',
    billingManagementMenuSubLabel2: 'デポジット管理',
    billingManagementMenuSubLabel3: 'オプションサービス',
    billingManagementMenuSubLabel4: '依頼済み一覧',
    coupon: 'クーポン設定',
    qrOrderManagementMenuLabel: 'QR Order管理',
    qrOrderManagementMenuSubLabel1: '店舗テーマ設定',
    qrOrderManagementMenuSubLabel2: 'ルール設定',
    qrOrderManagementMenuSubLabel3: 'テーブル一覧',
    qrOrderManagementMenuSubLabel4: 'QR Order分析',
    qrOrderManagementMenuSubLabel5: 'プリンター設定',
    settingsMenuLabel: '設定',
    settingsMenuSubLabel1: '管理者情報',
    settingsMenuSubLabel2: '外部ツール設定',
    videoMenuSub1: 'プレミアム動画',
    videoMenuSub2: '紹介動画（店舗投稿）',
    videoMenuSub3: '応援動画',
    introduction: '紹介コード'
  }
}
